export interface InventoryLevelResponse {
  variants: {
    admin_graphql_api_id: string
    inventory_quantity: number
  }[]
}

export const getInventoryLevel = (): Promise<InventoryLevelResponse> =>
  fetch('/api/inventory-level').then((r) => {
    if (!r.ok) throw new Error(`Inventory level fetch failed (${r.status})`)
    return r.json()
  })

export interface NewsletterResponse {
  success: boolean
  error?: string
}

export const subscribeNewsletter = (
  email: string,
  website: string
): Promise<NewsletterResponse> =>
  fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, website }),
  }).then((r) => {
    if (!r.ok) throw new Error(`Newsletter signup failed (${r.status})`)
    return r.json()
  })
